module.exports = __webpack_public_path__ + "static/media/guide-line-2.e7da82c6.svg";